export default function buildQuery (query) {
  if (!query) {
    return
  }
  const [sql = '', params = []] = query
  return params.reduce((sqlAcum, param) => {
    if (typeof param === 'string') {
      param = `$$$$${param}$$$$`
    }
    return sqlAcum.replace('%s', param)
  }, sql)
}
